import React, { useState, useEffect, useContext } from "react";
import { getScenarios } from "../../services/api";
import { Card, Spin } from "antd";

import { EmissionContext } from "../emission";

import { MomentFormat } from "../../tools";

export default function Description() {
  const { filterData } = useContext(EmissionContext);
  const [data, setData] = useState([]);
  const [Loading, setLoading] = useState(true);
  useEffect(() => {
    ScenarioList(filterData.scenarios);
  }, [filterData.scenarios]);

  const ScenarioList = async (scenario) => {
    setLoading(true);
    const res = await getScenarios();
    if (res.status === 200) {
      const name = scenario.map((item) => item.name);
      const result = res.data.filter((item) =>
        name.includes(item.scenario_name)
      );
      setData(result);
      setLoading(false);
    }
  };

  return (
    <Spin tip="Data Loading..." spinning={Loading}>
      {data.map((item) => (
        <Card className="rounded-lg border-2 shadow-lg p-4 mb-6 text-base">
          <h1 className="font-bold text-lg">{item.scenario_name}</h1>
          <p>
            <span className=" text-purple-500">by {item.owner.firstname}</span>
          </p>
          <p>
            {item.description ? (
              item.description
            ) : (
              <span className="text-gray-300">No description...</span>
            )}
          </p>
          <h5 className="text-sm font-normal">
            <span className="text-gray-400">Create</span>{" "}
            {MomentFormat(item.created_at)}
          </h5>
          <h5 className="text-sm font-normal">
            <span className="text-gray-400">Update</span>{" "}
            {MomentFormat(item.updated_at)}
          </h5>
        </Card>
      ))}
    </Spin>
  );
}
